export default "__VITE_ASSET__MsYmdYpo__"